import { Saga as Dashboard } from '../dashboard/sagas';
import { fork, all } from 'redux-saga/effects';

export function* watchSagas() {
    //Combine sagas with
    yield all([Dashboard()]);
    // OR
    // yield all([fork(FeatureSaga1)]);
}
